
{
  "familyId": "MET-INH-CITER",
  "questions": [
    {
      "id": "MET-INH-CITER-001",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "multiple_choice",
      "question": "Hoeveel centiliter (cl) is 2,5 liter?",
      "context": null,
      "options": ["250 cl", "25 cl", "2500 cl", "0,25 cl"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "l", "to": "cl" } }
      ],
      "supportAids": [
        { "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "l", "to": "cl", "value": 2.5, "highlight": true, "showAnimation": true } }
      ],
      "conceptId": "liter_to_centiliter",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Van liter naar centiliter ga je 2 treden naar beneden op het metrieke trapje. Elke trede is ×10, dus 2 treden = ×100. Berekening: 2,5 × 100 = 250 cl. Waarom ×100? Omdat er 100 centiliter in 1 liter gaan — 'centi' betekent honderdste. Check: 250 cl ÷ 100 = 2,5 l ✓",
        "solutionSteps": [
          "Bepaal het aantal treden: liter → deciliter → centiliter = 2 treden",
          "Elke trede naar beneden is ×10, dus 2 treden = ×100",
          "Vermenigvuldig: 2,5 × 100 = 250 cl",
          "Check: 250 ÷ 100 = 2,5 l ✓"
        ],
        "distractorExplanations": {
          "0": "Uitstekend! 2,5 liter × 100 = 250 centiliter. Je hebt het trapje goed gebruikt.",
          "1": "Je dacht waarschijnlijk dat je maar 1 trede naar beneden gaat (×10). Maar van liter naar centiliter zijn het 2 treden: liter → deciliter → centiliter. Dus ×100, niet ×10. Onthoud: 'centi' = honderdste.",
          "2": "Je dacht waarschijnlijk dat er 3 treden zijn (×1000). Maar van liter naar centiliter zijn het 2 treden (×100). 3 treden zou liter → milliliter zijn. Onthoud: l → cl = 2 treden, l → ml = 3 treden.",
          "3": "Je hebt gedeeld in plaats van vermenigvuldigd. Als je van een grote eenheid (liter) naar een kleine eenheid (centiliter) gaat, wordt het getal groter — dus vermenigvuldig je. Onthoud: groot → klein = ×."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-trap-1-trede-l-cl", "label": "Denkt dat l→cl maar 1 trede is (×10)", "optionIndex": 1 },
          { "id": "met.inhoud-trap-3-treden-l-cl", "label": "Denkt dat l→cl 3 treden is (×1000)", "optionIndex": 2 },
          { "id": "met.inhoud-trap-richting-fout-l-cl", "label": "Deelt waar vermenigvuldigen moet (groot→klein)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-CITER-002",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "multiple_choice",
      "question": "Een flesje bevat 33 cl. Hoeveel liter is dat?",
      "context": null,
      "options": ["330 liter", "3,3 liter", "0,33 liter", "0,033 liter"],
      "correctAnswer": 2,
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "cl", "to": "l" } }
      ],
      "supportAids": [
        { "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "cl", "to": "l", "value": 33, "highlight": true, "showAnimation": true } }
      ],
      "conceptId": "centiliter_to_liter",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Van centiliter naar liter ga je 2 treden naar boven op het trapje. Elke trede is ÷10, dus 2 treden = ÷100. Berekening: 33 ÷ 100 = 0,33 liter. Waarom ÷100? Omdat 100 centiliter samen 1 liter vormen. Check: 0,33 × 100 = 33 cl ✓",
        "solutionSteps": [
          "Bepaal het aantal treden: centiliter → deciliter → liter = 2 treden",
          "Elke trede naar boven is ÷10, dus 2 treden = ÷100",
          "Deel: 33 ÷ 100 = 0,33 liter",
          "Check: 0,33 × 100 = 33 cl ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt vermenigvuldigd in plaats van gedeeld. Als je van een kleine eenheid (cl) naar een grote eenheid (l) gaat, wordt het getal kleiner — dus deel je. Onthoud: klein → groot = ÷.",
          "1": "Je dacht waarschijnlijk dat je maar 1 trede naar boven gaat (÷10). Maar van centiliter naar liter zijn het 2 treden (÷100). 33 ÷ 10 = 3,3 — dat klopt niet. Onthoud: cl → l = 2 treden.",
          "2": "Goed gedaan! 33 centiliter ÷ 100 = 0,33 liter.",
          "3": "Je dacht waarschijnlijk dat er 3 treden zijn (÷1000). Maar van centiliter naar liter zijn het 2 treden (÷100), niet 3. 3 treden zou milliliter → liter zijn. Onthoud: cl → l = ÷100."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-trap-richting-fout-cl-l", "label": "Vermenigvuldigt waar delen moet (klein→groot)", "optionIndex": 0 },
          { "id": "met.inhoud-trap-1-trede-cl-l", "label": "Denkt dat cl→l maar 1 trede is (÷10)", "optionIndex": 1 },
          { "id": "met.inhoud-trap-3-treden-cl-l", "label": "Denkt dat cl→l 3 treden is (÷1000)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-CITER-003",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "multiple_choice",
      "question": "Een laborant heeft 4 deciliter vloeistof. Hoeveel centiliter is dat?",
      "context": "Een laborant in een ziekenhuis moet medicijnen nauwkeurig afmeten.",
      "options": ["400 cl", "40 cl", "4 cl", "0,4 cl"],
      "correctAnswer": 1,
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "dl", "to": "cl" } }
      ],
      "supportAids": [
        { "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "dl", "to": "cl", "value": 4, "highlight": true, "showAnimation": true } }
      ],
      "conceptId": "deciliter_to_centiliter",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Van deciliter naar centiliter ga je 1 trede naar beneden op het trapje. Elke trede is ×10. Berekening: 4 × 10 = 40 cl. Waarom ×10? Omdat er 10 centiliter in 1 deciliter gaan — 'deci' is tiende, 'centi' is honderdste. Check: 40 cl ÷ 10 = 4 dl ✓",
        "solutionSteps": [
          "Bepaal het aantal treden: deciliter → centiliter = 1 trede",
          "1 trede naar beneden = ×10",
          "Vermenigvuldig: 4 × 10 = 40 cl",
          "Check: 40 ÷ 10 = 4 dl ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 2 treden naar beneden gaat (×100). Maar van deciliter naar centiliter is het maar 1 trede (×10). 2 treden zou deciliter → milliliter zijn. Onthoud: dl → cl = 1 trede.",
          "1": "Goed! 4 deciliter × 10 = 40 centiliter.",
          "2": "Je dacht waarschijnlijk dat deciliter en centiliter dezelfde eenheid zijn. Maar 1 dl = 10 cl. 'Deci' = tiende, 'centi' = honderdste. Onthoud: dl is groter dan cl.",
          "3": "Je hebt gedeeld in plaats van vermenigvuldigd. Van een grotere eenheid (dl) naar een kleinere eenheid (cl) wordt het getal groter. Onthoud: groot → klein = ×."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-trap-2-treden-dl-cl", "label": "Denkt dat dl→cl 2 treden is (×100)", "optionIndex": 0 },
          { "id": "met.inhoud-dl-cl-gelijk", "label": "Behandelt deciliter en centiliter als gelijk", "optionIndex": 2 },
          { "id": "met.inhoud-trap-richting-fout-dl-cl", "label": "Deelt waar vermenigvuldigen moet (groot→klein)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-CITER-004",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "fill_in",
      "question": "Een parfumflesje bevat 75 ml. Hoeveel centiliter is dat? Typ je antwoord in cl.",
      "context": "Een apotheker rekent hoeveelheden om voor een recept.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["7,5", "7.5", "7,5 cl", "7.5 cl"],
        "caseSensitive": false,
        "placeholder": "? cl"
      },
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "ml", "to": "cl" } }
      ],
      "supportAids": [
        { "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "ml", "to": "cl", "value": 75, "highlight": true, "showAnimation": true } }
      ],
      "conceptId": "milliliter_to_centiliter_fill",
      "variantIndex": 4,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Van milliliter naar centiliter ga je 1 trede naar boven: ÷10. Berekening: 75 ÷ 10 = 7,5 cl. Waarom ÷10? Omdat er 10 milliliter in 1 centiliter gaan. Check: 7,5 × 10 = 75 ml ✓",
        "solutionSteps": [
          "Bepaal het aantal treden: milliliter → centiliter = 1 trede",
          "1 trede naar boven = ÷10",
          "Deel: 75 ÷ 10 = 7,5 cl",
          "Check: 7,5 × 10 = 75 ml ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-ml-cl-conversie-fout", "label": "Maakt fout bij ml→cl conversie (÷10)" }
        ]
      }
    },
    {
      "id": "MET-INH-CITER-005",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "fill_in",
      "question": "Een cocktailrecept vraagt om 1,5 dl sinaasappelsap. Hoeveel centiliter is dat? Typ je antwoord.",
      "context": "Een barista bereidt een cocktail volgens een recept.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["15", "15 cl", "15cl"],
        "caseSensitive": false,
        "placeholder": "? cl"
      },
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "dl", "to": "cl" } }
      ],
      "supportAids": [
        { "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "dl", "to": "cl", "value": 1.5, "highlight": true, "showAnimation": true } }
      ],
      "conceptId": "deciliter_to_centiliter_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Van deciliter naar centiliter ga je 1 trede naar beneden: ×10. Berekening: 1,5 × 10 = 15 cl. Waarom ×10? Omdat er 10 centiliter in 1 deciliter gaan. Check: 15 cl ÷ 10 = 1,5 dl ✓",
        "solutionSteps": [
          "Bepaal de trede: deciliter → centiliter = 1 trede naar beneden",
          "1 trede = ×10",
          "Vermenigvuldig: 1,5 × 10 = 15 cl",
          "Check: 15 ÷ 10 = 1,5 dl ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-dl-cl-conversie-fout", "label": "Maakt fout bij dl→cl conversie (×10)" }
        ]
      }
    },
    {
      "id": "MET-INH-CITER-006",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "ordering",
      "question": "Zet deze hoeveelheden op volgorde van klein naar groot.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["50 ml", "8 cl", "3 dl", "0,5 l", "1,2 l"],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "ml", "to": "l" } }
      ],
      "supportAids": [
        { "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "ml", "to": "l", "highlight": true } }
      ],
      "conceptId": "volume_ordering_small_to_large",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Reken eerst alles om naar dezelfde eenheid (bv. ml): 50 ml = 50 ml, 8 cl = 80 ml, 3 dl = 300 ml, 0,5 l = 500 ml, 1,2 l = 1200 ml. Op volgorde: 50 < 80 < 300 < 500 < 1200.",
        "solutionSteps": [
          "Reken elke waarde om naar ml",
          "50 ml | 8 cl=80 ml | 3 dl=300 ml | 0,5 l=500 ml | 1,2 l=1200 ml",
          "Sorteer: 50 < 80 < 300 < 500 < 1200"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "MET-INH-CITER-007",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "matching",
      "question": "Welke hoeveelheden zijn aan elkaar gelijk?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "2 l", "right": "200 cl" },
          { "left": "5 dl", "right": "50 cl" },
          { "left": "250 ml", "right": "25 cl" },
          { "left": "1,5 l", "right": "150 cl" },
          { "left": "40 cl", "right": "400 ml" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "ml", "to": "l" } }
      ],
      "conceptId": "volume_equivalents_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Reken steeds om naar cl (of ml) en zoek de gelijke waarde. 2 l = 200 cl. 5 dl = 50 cl. 250 ml = 25 cl. 1,5 l = 150 cl. 40 cl = 400 ml.",
        "solutionSteps": [
          "Per paar: zet beide kanten om naar dezelfde eenheid",
          "2 l = 200 cl; 5 dl = 50 cl; 250 ml = 25 cl; 1,5 l = 150 cl; 40 cl = 400 ml",
          "Koppel waarden die gelijk zijn"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "MET-INH-CITER-008",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "true_false_series",
      "question": "Beoordeel elke omrekening: klopt het of niet?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "1 liter = 100 cl", "isTrue": true, "explanation": "Klopt: l → cl is 2 treden naar beneden (×100)." },
          { "text": "1 dl = 10 ml", "isTrue": false, "explanation": "Onjuist. 1 dl = 100 ml (dl → ml is 2 treden naar beneden, dus ×100). Veelgemaakte fout: maar 1 trede tellen." },
          { "text": "5 cl = 50 ml", "isTrue": true, "explanation": "Klopt: cl → ml is 1 trede naar beneden (×10), dus 5 cl = 50 ml." },
          { "text": "200 ml = 2 dl", "isTrue": true, "explanation": "Klopt: ml → dl is 2 treden naar boven (÷100), dus 200 ÷ 100 = 2 dl." },
          { "text": "0,5 l = 5 cl", "isTrue": false, "explanation": "Onjuist. 0,5 l × 100 = 50 cl, niet 5 cl." },
          { "text": "75 cl = 0,75 l", "isTrue": true, "explanation": "Klopt: cl → l is 2 treden naar boven (÷100), dus 75 ÷ 100 = 0,75 l." }
        ]
      },
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "ml", "to": "l" } }
      ],
      "supportAids": [
        { "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "ml", "to": "l", "highlight": true } }
      ],
      "conceptId": "volume_conversions_tf",
      "variantIndex": 8,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Tel per omrekening het aantal treden op het trapje en bepaal richting. Naar beneden = ×10 per trede; naar boven = ÷10 per trede. Eén veelgemaakte fout: 0,5 l → 5 cl in plaats van 50 cl (1 trede vergeten).",
        "solutionSteps": [
          "Bepaal richting (groot → klein = ×; klein → groot = ÷)",
          "Tel het aantal treden",
          "Pas ×10 / ÷10 per trede toe",
          "Vergelijk met de stelling"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "MET-INH-CITER-009",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "fill_in",
      "question": "Een fles cola bevat 1,5 liter. Hoeveel glazen van 25 cl kun je hieruit volledig schenken? Typ het aantal glazen.",
      "context": "Op een verjaardag wordt cola geschonken in glazen van 25 cl.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["6", "6 glazen"],
        "caseSensitive": false,
        "placeholder": "? glazen"
      },
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "l", "to": "cl" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Stappenplan", "content": "1) Zet alles in dezelfde eenheid: 1,5 l = 150 cl. 2) Deel: 150 ÷ 25 = 6. Antwoord: 6 volle glazen.", "icon": "lightbulb" } }
      ],
      "conceptId": "volume_multistep_context",
      "variantIndex": 9,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Twee stappen. Stap 1: zet 1,5 l om naar cl → 1,5 × 100 = 150 cl. Stap 2: deel door glasgrootte → 150 ÷ 25 = 6 volle glazen. Belangrijk: eenheden gelijktrekken vóór delen.",
        "solutionSteps": [
          "Zet 1,5 l om naar cl: 1,5 × 100 = 150 cl",
          "Deel door glasgrootte: 150 ÷ 25 = 6",
          "Antwoord: 6 volle glazen"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.eenheden-niet-gelijktrekken", "label": "Vergeet eenheden gelijk te trekken vóór delen" }
        ]
      }
    },
    {
      "id": "MET-INH-CITER-010",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "categorize",
      "question": "Welke hoeveelheid is kleiner dan een halve liter (< 0,5 l), precies een halve liter, of groter dan een halve liter?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["< 0,5 l", "= 0,5 l", "> 0,5 l"],
        "items": [
          { "text": "33 cl", "correctCategory": 0 },
          { "text": "250 ml", "correctCategory": 0 },
          { "text": "4 dl", "correctCategory": 0 },
          { "text": "50 cl", "correctCategory": 1 },
          { "text": "500 ml", "correctCategory": 1 },
          { "text": "5 dl", "correctCategory": 1 },
          { "text": "75 cl", "correctCategory": 2 },
          { "text": "1 l", "correctCategory": 2 },
          { "text": "600 ml", "correctCategory": 2 }
        ]
      },
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "ml", "to": "l" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Eerst gelijktrekken", "content": "Reken alles om naar ml (of cl) en vergelijk met 500 ml (= 50 cl = 0,5 l). Dan zie je in één oogopslag wie groter, gelijk of kleiner is.", "icon": "lightbulb" } }
      ],
      "conceptId": "volume_compare_categorize",
      "variantIndex": 10,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Reken eerst alles om naar ml en vergelijk met 500 ml. Kleiner: 33 cl=330, 250 ml, 4 dl=400. Gelijk: 50 cl=500, 500 ml, 5 dl=500. Groter: 75 cl=750, 1 l=1000, 600 ml.",
        "solutionSteps": [
          "Reken elke waarde om naar ml",
          "Vergelijk met 500 ml",
          "Sorteer in kleiner/gelijk/groter"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    }
  ]
}
